import React, {useCallback} from 'react';
import {OverlayTrigger} from 'shared/components/OverlayTrigger';
import {useRoomPlannerContext} from 'components/customer/RoomPlanner/components/RoomPlannerContext';
import FloatingMenuButton, {
    FloatingMenuButtonIcon,
} from 'components/customer/RoomPlanner/components/common/FloatingMenuButton';
import {confirmPlaceholderDelete} from 'components/customer/RoomPlanner/helpers/placeholder/confirmDelete';
import {useDialogContext} from 'contexts/DialogContext';
import {
    useIsMobileLandscape,
    useIsPortraitDevices,
} from 'shared/helpers/DeviceSize';

const PlaceholderDelete = () => {
    const isMobileLandscape = useIsMobileLandscape();
    const isPortraitDevices = useIsPortraitDevices();
    const {
        selectedCabinetGroup,
        setSelectedCabinetGroup,
        placeholderListRef,
        cabinetGroupListRef,
    } = useRoomPlannerContext();
    const {showDialog} = useDialogContext();

    const handleDelete = useCallback(() => {
        if (
            !selectedCabinetGroup?.userData?.isPlaceholder ||
            !placeholderListRef ||
            !cabinetGroupListRef
        ) {
            return;
        }

        confirmPlaceholderDelete({
            group: selectedCabinetGroup,
            placeholderListRef,
            cabinetGroupListRef,
            showDialog,
            onDeleted: () => setSelectedCabinetGroup?.(null),
        });
    }, [
        selectedCabinetGroup,
        placeholderListRef,
        cabinetGroupListRef,
        setSelectedCabinetGroup,
        showDialog,
    ]);

    return (
        <OverlayTrigger
            placement="top"
            overlay={<strong>Delete (Delete or Backspace)</strong>}>
            <FloatingMenuButton onClick={handleDelete}>
                <FloatingMenuButtonIcon
                    className="icon_button"
                    color={
                        isMobileLandscape || isPortraitDevices
                            ? 'primary'
                            : '#b2bec3'
                    }
                    iconName="Layout-Delete.svg"
                />
                <label>Delete</label>
            </FloatingMenuButton>
        </OverlayTrigger>
    );
};

export default PlaceholderDelete;
